import axios from 'axios';
import { getAccessToken } from 'Helpers/session';
import { isEmpty } from 'lodash';
import errorHandler from 'Utils/error-handler';

export const fetchLanguageSetting = async () => {
  const url = `${process.env.API_URL}/${process.env.API_VER}/settings/language/fetch`;
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: {},
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.data?.settings;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchLanguageSetting();
      const { value, code, message, stack } = await errorHandler.response(error, callback);
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};
